// extracted by mini-css-extract-plugin
export var numpadContainer = "_oi-1";
export var phoneButton = "_oi-0";